import React, { ReactElement, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { Button } from 'primereact/button';

import { Property } from '../../../shared/schema/PropertySchema';

import grundrissLogo from '../grundriss-symbol.svg';
import s from '../Portfolio.module.scss';
import '../../Table/Table.scss';
import CustomButton from '../../Buttons/CustomButton';

interface PropertiesProps {
  rows: Property[];
  onSelectProperty: (property: Property) => void;
  handlePropertyClicked: (property: Property) => void;
}

export default function PropertyGroup(props: PropertiesProps): ReactElement {
  const { rows, onSelectProperty, handlePropertyClicked } = props;
  const [displayedRowCount, setDisplayedRowCount] = useState(
    Math.min(rows.length, 6)
  );

  const renderPrice = (price: string): string => {
    let formatedPrice = price;
    if (!formatedPrice) return '-';

    if (formatedPrice.match(/\d+/gi) && !formatedPrice.includes('€')) {
      formatedPrice = formatedPrice.replace(/\d+/gi, (x) => `${x} €`);
    }

    return formatedPrice.replace(/\d+/gi, (x) =>
      Math.round(Number(x)).toLocaleString('de-DE')
    );
  };

  return (
    <>
      {rows.map((r, i) => {
        if (i >= displayedRowCount) return <></>;

        const floor = r.floor || '-';
        const flatNumber = r.flatNumber || '-';
        return (
          <div
            key={r.id}
            role="button"
            className={s.flat}
            onClick={() => {
              handlePropertyClicked(r);
            }}
            onKeyPress={() => null}
            tabIndex={0}
          >
            <div className={s.layoutButtonContainer}>
              {r.images.length > 0 && (
                <Button
                  className={`${s.layoutButton} ${s.enabled}`}
                  onClick={(event) => {
                    onSelectProperty(r);
                    event.stopPropagation();
                  }}
                  tooltip="Grundriss"
                  tooltipOptions={{ position: 'top' }}
                >
                  <img alt="Grundriss Wohnung" src={grundrissLogo} />
                </Button>
              )}
              {r.images.length === 0 && (
                <Button
                  className={s.layoutButton}
                  onClick={() => onSelectProperty(r)}
                  tooltip="Kein Grundriss vorhanden"
                  tooltipOptions={{ position: 'top' }}
                >
                  <img alt="Grundriss Wohnung" src={grundrissLogo} />
                </Button>
              )}
            </div>
            <div className={s.topContainer}>
              <div className={s.top}>
                {
                  /* eslint-disable-next-line no-restricted-globals */
                  isNaN(flatNumber) ? flatNumber : `TOP ${flatNumber}`
                }
              </div>
            </div>
            <div className={s.floor}>
              {/* eslint-disable-next-line no-restricted-globals */}
              {isNaN(floor as any) ? floor : `${parseFloat(floor)}.Etage`}
            </div>

            <div className={s.price}>{renderPrice(r.price)}</div>

            <div className={s.area}>
              {Math.round(r.area)} m<sup>2</sup>
            </div>
            <div className={s.rooms}>
              {r.rooms !== null ? `${r.rooms} Zimmer` : ''}
            </div>

            <div className={s.flatLinkContainer}>
              <FontAwesomeIcon
                size="2x"
                color="#daa48a"
                icon={faEnvelope}
                className={s.flatLink}
              />
            </div>
          </div>
        );
      })}
      {displayedRowCount < rows.length && (
        <div style={{ marginTop: 6 }}>
          <CustomButton
            onClick={() => {
              setDisplayedRowCount(
                Math.min(displayedRowCount + 6, rows.length)
              );
            }}
          >
            Mehr laden
          </CustomButton>
        </div>
      )}
    </>
  );
}
